module.exports = __webpack_public_path__ + "img/katakana.c976ef1b.gif";